import { loadQualifiedDocsChat } from '@lib/qualified';
import { disableAnalytics } from '@config';

export const lazyLoadedScripts = () => {
  if (!disableAnalytics) {
    loadQualifiedDocsChat();
  }
};
